/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseScheduledBroadcastResponse } from '../../models/api-response-scheduled-broadcast-response';
import { ScheduledBroadcastResponse } from '../../models/scheduled-broadcast-response';

export interface UpdateScheduledBroadcast$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body: ScheduledBroadcastResponse
}

export function updateScheduledBroadcast(http: HttpClient, rootUrl: string, params: UpdateScheduledBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseScheduledBroadcastResponse>> {
  const rb = new RequestBuilder(rootUrl, updateScheduledBroadcast.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseScheduledBroadcastResponse>;
    })
  );
}

updateScheduledBroadcast.PATH = '/v1/api/ui/broadcast/{reference}';
